<template>
  <div>
    <q-select
      v-model="grupo"
      @filter="filtrarGrupo"
      :options="options"
      dense
      class="select"
      outlined
      option-label="nome"
      label="Selecione o Grupo"
      label-color="grey-6"
      :bg-color="disable ? 'brand-7' : ''"
      :disable="disable"
    >
      <template v-slot:no-option>
        <q-item>
          <q-item-section class="text-italic text-grey">
            Nenhum grupo encontrado
          </q-item-section>
        </q-item>
      </template></q-select
    >
  </div>
</template>

<script>
import { useStore } from "vuex";
import { ref, watch } from "vue";

export default {
  emits: ["enviarGrupo"],
  props: [
    "resetar",
    "grupoUuid",
    "disable",
    "catalogoUuid",
    "normalValue",
    "model",
  ],
  setup(props, { emit }) {
    const store = useStore();

    const grupo = ref(props.model);
    const options = ref([]);

    const listarGrupo = async (val) => {
      try {
        const response = await store.dispatch(
          "ferramentaria/listarGruposCriados",
          {
            unidadeId: store.state.org.unidadeData.id,
            catalogoUuid:
              store.state.ferramentaria.catalogoUuid == null &&
              props.catalogoUuid != ""
                ? props.catalogoUuid
                : store.state.ferramentaria.catalogoUuid,
            nome: val,
            page: 1,
            per_page: 10,
          }
        );
        options.value = response.data.resultado.dados;
      } catch (error) {
        console.log(error);
      }
    };

    const buscarGrupo = async () => {
      console.log("buscarGrupo");
      if (props.grupoUuid === "" || props.grupoUuid === undefined) {
        return;
      }
      try {
        const response = await store.dispatch(
          "ferramentaria/listarGruposCriados",
          {
            unidadeId: store.state.org.unidadeData.id,
            catalogoUuid: store.state.ferramentaria.catalogoUuid,
            catalogoGrupoUuid: props.grupoUuid,
            page: 1,
            per_page: 10,
          }
        );
        grupo.value = response.data.resultado.dados[0];
      } catch (error) {
        console.log(error);
      }
    };

    watch(
      () => grupo.value,
      () => {
        emit("enviarGrupo", grupo.value);
      }
    );

    watch(
      () => props.resetar,
      () => {
        grupo.value = "";
      }
    );

    watch(
      () => props.grupoUuid,
      () => {
        buscarGrupo();
      }
    );

    const getValue = async () => {
      grupo.value = props.normalValue;
    };

    // onMounted(getValue);

    return {
      listarGrupo,
      options,
      grupo,
      getValue,
      buscarGrupo,
      filtrarGrupo(val, update) {
        listarGrupo(val);
        setTimeout(() => {
          update();
        }, 500);
      },
    };
  },
};
</script>

<style scoped>
@media (max-width: 600px) {
  .select {
    font-size: 12px;
  }
}
</style>
